// extracted by mini-css-extract-plugin
export default {"row":"Addons_row__9mx+p","icon":"Addons_icon__b9hoR","value":"Addons_value__qAwN1"};